export const frontSkillsMock = [
  {
    skill: {
      src: "/images/skills/react.png",
      alt: "react",
      width: "60",
      height: "60",
    },
  },
  {
    skill: {
      src: "/images/skills/next.png",
      alt: "next",
      width: "90",
      height: "65",
    },
  },
  {
    skill: {
      src: "/images/skills/angular.png",
      alt: "angular",
      width: "60",
      height: "65",
    },
  },
  {
    skill: {
      src: "/images/skills/typescript.png",
      alt: "typescript",
      width: "55",
      height: "60",
    },
  },
  {
    skill: {
      src: "/images/skills/sass.png",
      alt: "sass",
      width: "90",
      height: "60",
    },
  },
  {
    skill: {
      src: "/images/skills/html.png",
      alt: "html",
      width: "60",
      height: "65",
    },
  },
  {
    skill: {
      src: "/images/skills/css.png",
      alt: "css",
      width: "60",
      height: "70",
    },
  },
];
